"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVirtualFloatingLink = void 0;
var _index = require("../forks/floating/index");
var _plateLink = require("@udecode/plate-link");
var useVirtualFloatingLink = function useVirtualFloatingLink(_ref) {
  var editorId = _ref.editorId,
    floatingOptions = _objectWithoutProperties(_ref, ["editorId"]);
  return (0, _index.useVirtualFloating)(_objectSpread({
    onOpenChange: function onOpenChange(open) {
      return _plateLink.floatingLinkActions.openEditorId(open ? editorId : null);
    }
  }, floatingOptions));
};
exports.useVirtualFloatingLink = useVirtualFloatingLink;